enum IProgressStrokeLinecap {
	Round = 'round',
	Square = 'square'
}

export default IProgressStrokeLinecap;
